export enum EntityType {
    Relation = 'relation',
    Project = 'project',
    Task = 'task',
    Order = 'order',
    Article = 'article',
}

export enum Errors {
    EntityNotFound,
    CompendaNotResponding,
}

export enum CompendaStatus {
    Opened = 'opened',
    Closed = 'closed',
    NotFound = 'not found',
}

export interface CompendaEventDetail {
    bron: EntityType,
    bronid: number,
    status: CompendaStatus,
}
